module.exports = __webpack_public_path__ + "img/chair.24b01af9.jpg";